import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Loader from "../child/Loder";
import SuccessAlert from "../child/Alert/SuccessAlert";
import DengerAlert from "../child/Alert/DengerAlert";
import { fetchAuditLogById } from "../services/auditService";
import moment from "moment";
import { formatAction } from "../../utils/formatAction";

const ViewAuditHistoryPageNew = () => {
  const { id } = useParams();

  const [logData, setLogData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const MODERATOR_ACTIONS = [
    { label: "Approve Content", value: "APPROVE_CONTENT" },
    { label: "Remove Content", value: "REMOVE_CONTENT" },
    { label: "Clear Profile Fields", value: "CLEAR_PROFILE_FIELDS" },
    { label: "Issue Warning", value: "ISSUE_WARNING" },
    { label: "Suspend User", value: "SUSPEND_USER" },
    { label: "UnSuspend User", value: "UNSUSPEND USER" },
    { label: "Ban User", value: "BAN_USER" },
    { label: "UnBan User", value: "UNBAN_USER" },
    { label: "Escalate to Admin", value: "ESCALATE_TO_ADMIN" },
  ];


  const getModeratorActionLabel = (action) => {
    const found = MODERATOR_ACTIONS.find(a => a.value === action);
    return found ? found.label : formatAction(action);
  };
  useEffect(() => {
    const getAuditLogDetails = async () => {
      try {
        if (!id) return;
        setLoading(true);

        const res = await fetchAuditLogById(id);

        if (res?.data?.status === 1) {
          setLogData(res.data.data);
        } else {
          setErrorMessage(res?.data?.message || "Failed to fetch audit log");
          setTimeout(() => setErrorMessage(""), 3000);
        }
      } catch (err) {
        console.error("🚨 Error fetching audit log by ID:", err);
        setErrorMessage(err.response?.data?.message || err.message);
        setTimeout(() => setErrorMessage(""), 3000);
      } finally {
        setLoading(false);
      }
    };

    getAuditLogDetails();
  }, [id]);

  if (loading) return <Loader />;

  if (!logData) {
    return <div className="text-center p-5">No audit data found.</div>;
  }
  const isModerationCase = !!logData?.reportId;

  const getCaseType = () => {
    if (!logData?.reportId) return "System Action";
    if (logData.reportId.isReport) return "Reported Content";
    if (logData.reportId.isBlock) return "User Block";
    return "Moderation Case";
  };

  const renderBeforeAfter = () => {
    if (!logData.before || !logData.after) return null;

    if (isModerationCase && logData.before?.status && logData.after?.status) {
      return (
        <div className="mt-4">
          <div className="form-label fw-bold">Status Change</div>
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead className="table-light">
                <tr>
                  <th>Before</th>
                  <th>After</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{logData.before.status}</td>
                  <td>{logData.after.status}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      );
    }

    // Handle Vault Unlock Action
    if (logData.action === "vault_unlock") {
      return (
        <div className="mt-4">
          <div className="form-label fw-bold">Vault Unlock Changes</div>
          <div className="table-responsive">
            <table className="table table-bordered align-middle">
              <thead className="table-light">
                <tr>
                  <th>Field</th>
                  <th>Before</th>
                  <th>After</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Completed Tiers</td>
                  <td>
                    {logData.before.completedTiers?.length
                      ? logData.before.completedTiers.join(", ")
                      : "None"}
                  </td>
                  <td>
                    {logData.after.completedTiers?.length
                      ? logData.after.completedTiers.join(", ")
                      : "None"}
                  </td>
                </tr>
                <tr>
                  <td>Reward Given</td>
                  <td>{logData.before.rewardGiven ? "Yes" : "No"}</td>
                  <td>{logData.after.rewardGiven ? "Yes" : "No"}</td>
                </tr>
                <tr>
                  <td>Reveal Together</td>
                  <td>{logData.before.revealTogether ? "Yes" : "No"}</td>
                  <td>{logData.after.revealTogether ? "Yes" : "No"}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      );
    }

    // Handle Match Override Action
    if (logData.action === "match_override") {
      return (
        <div className="mt-4">
          <div className="form-label fw-bold">Match Override Changes</div>
          <div className="table-responsive">
            <table className="table table-bordered align-middle">
              <thead className="table-light">
                <tr>
                  <th>Field</th>
                  <th>Before</th>
                  <th>After</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Status</td>
                  <td>{logData.before.status || "N/A"}</td>
                  <td>{logData.after.status || "N/A"}</td>
                </tr>
                <tr>
                  <td>Reason</td>
                  <td>{logData.before.reason || "N/A"}</td>
                  <td>{logData.after.reason || "N/A"}</td>
                </tr>
                <tr>
                  <td>Override At</td>
                  <td>N/A</td>
                  <td>
                    {logData.after.overrideAt
                      ? moment(logData.after.overrideAt).format(
                        "DD-MM-YYYY HH:mm:ss"
                      )
                      : "N/A"}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      );
    }

    // Handle Coins Added Action
    if (logData.action === "coins_added") {
      return (
        <div className="mt-4">
          <div className="form-label fw-bold">Coins Adjustment</div>
          <div className="table-responsive">
            <table className="table table-bordered align-middle">
              <thead className="table-light">
                <tr>
                  <th>Field</th>
                  <th>Before</th>
                  <th>After</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Coins</td>
                  <td>{logData.before?.coins ?? "N/A"}</td>
                  <td>{logData.after?.coins ?? "N/A"}</td>
                </tr>

              </tbody>
            </table>
          </div>
        </div>
      );
    }

    if (logData.action === "resend") {
      return (
        <div className="mt-4">
          <div className="form-label fw-bold">Resend Notification Summary</div>
          <div className="table-responsive">
            <table className="table table-bordered align-middle">
              <thead className="table-light">
                <tr>
                  <th>Type</th>
                  <th>Users</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Success</td>
                  <td>{logData.after?.deliverySummary?.success?.length || 0} users</td>
                </tr>
                <tr>
                  <td>Failed</td>
                  <td>{logData.after?.deliverySummary?.failed?.length || 0} users</td>
                </tr>
                <tr>
                  <td>No Token</td>
                  <td>{logData.after?.deliverySummary?.noToken?.length || 0} users</td>
                </tr>
                <tr>
                  <td>User Setting Disabled</td>
                  <td>{logData.after?.deliverySummary?.userSettingDisabled?.length || 0} users</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      );
    }

    if (logData.action === "delete_user_photo") {
      const beforePhotos = logData.before.userPhotos || [];
      const afterPhotos = logData.after.userPhotos || [];
      const deletedPhotos = beforePhotos.filter((url) => !afterPhotos.includes(url));

      return (
        <div className="mt-4">
          <div className="row">
            <div className="col-md-6">
              <div className="form-label fw-bold">Before</div>
              <div className="d-flex flex-wrap gap-2">
                {beforePhotos.map((url, index) => (
                  <img
                    key={index}
                    src={url}
                    alt={`before-${index}`}
                    style={{
                      width: "80px",
                      height: "80px",
                      objectFit: "cover",
                      border: deletedPhotos.includes(url) ? "2px solid red" : "1px solid #ccc",
                      borderRadius: "4px",
                    }}
                  />
                ))}
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-label fw-bold">After</div>
              <div className="d-flex flex-wrap gap-2">
                {afterPhotos.map((url, index) => (
                  <img
                    key={index}
                    src={url}
                    alt={`after-${index}`}
                    style={{
                      width: "80px",
                      height: "80px",
                      objectFit: "cover",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                    }}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      );
    }

    if (logData.action === "grant_trial") {
      return (
        <div className="mt-4">
          <div className="form-label fw-bold">Grant Trial Changes</div>
          <div className="table-responsive">
            <table className="table table-bordered align-middle">
              <thead className="table-light">
                <tr>
                  <th>Field</th>
                  <th>Before</th>
                  <th>After</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Curiozz Plus</td>
                  <td>{logData.before?.entitlements?.curiouzzPlus ? "Yes" : "No"}</td>
                  <td>{logData.after?.entitlements?.curiouzzPlus ? "Yes" : "No"}</td>
                </tr>
                <tr>
                  <td>Active Subscription</td>
                  <td>{logData.before?.activeSubscription ?? "None"}</td>
                  <td>{logData.after?.activeSubscription ?? "None"}</td>
                </tr>
                <tr>
                  <td>Perks</td>
                  <td>
                    {logData.before?.entitlements?.perks?.length
                      ? logData.before.entitlements.perks.join(", ")
                      : "None"}
                  </td>
                  <td>
                    {logData.after?.entitlements?.perks?.length
                      ? logData.after.entitlements.perks.join(", ")
                      : "None"}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      );
    }

   


    // Default fallback
    return (
      <div className="mt-4">
        <h5 className="fw-bold mb-3">Before / After Details</h5>
        <pre className="p-3 bg-light rounded">
          {JSON.stringify(
            { before: logData.before, after: logData.after },
            null,
            2
          )}
        </pre>
      </div>
    );
  };

   const renderGrantTrialChanges = () => {
      const meta = logData.meta || {};

      return (
        <div className="mt-4">
          <div className="form-label fw-bold">Grant Trial Changes</div>

          <table className="table table-bordered align-middle">
            <thead className="table-light">
              <tr>
                <th>Field</th>
                <th>Before</th>
                <th>After</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>Curiozz Plus</td>
                <td>{logData.before?.entitlements?.curiouzzPlus ? "Yes" : "No"}</td>
                <td>{logData.after?.entitlements?.curiouzzPlus ? "Yes" : "Yes"}</td>
              </tr>

              <tr>
                <td>Trial Status</td>
                <td>Inactive</td>
                <td>Active</td>
              </tr>

              <tr>
                <td>Trial Duration</td>
                <td>N/A</td>
                <td>{meta.trialDurationDays ? `${meta.trialDurationDays} days` : "N/A"}</td>
              </tr>

              <tr>
                <td>Trial Start</td>
                <td>N/A</td>
                <td>
                  {meta.trialStartDate
                    ? moment(meta.trialStartDate).format("DD-MM-YYYY")
                    : "N/A"}
                </td>
              </tr>

              <tr>
                <td>Trial End</td>
                <td>N/A</td>
                <td>
                  {meta.trialEndDate
                    ? moment(meta.trialEndDate).format("DD-MM-YYYY")
                    : "N/A"}
                </td>
              </tr>

              <tr>
                <td>User Notified</td>
                <td>N/A</td>
                <td>{meta.notifyUsers ? "Yes" : "No"}</td>
              </tr>
            </tbody>
          </table>
        </div>
      );
    };


  return (
    <div className="row gy-4">
      <div className="col-md-12">
        <div className="card h-100">
          <div className="card-body p-24">
            {successMessage && (
              <SuccessAlert
                message={successMessage}
                onClose={() => setSuccessMessage("")}
              />
            )}
            {errorMessage && (
              <DengerAlert
                message={errorMessage}
                onClose={() => setErrorMessage("")}
              />
            )}

            <div className="row">
              <div className="col-md-4 mb-3">
                <label className="form-label fw-bold">Action:</label>
                {/* <div>{formatAction(logData.action)}</div>
                 */}
                <div>
                  {isModerationCase
                    ? getModeratorActionLabel(logData.action)
                    : formatAction(logData.action)}
                </div>
              </div>

              {isModerationCase && logData?.reportId?.ownerUserId && (
                <div className="col-md-4 mb-3">
                  <label className="form-label fw-bold">Reported By:</label>
                  <div>{logData.reportId.ownerUserId.email}</div>
                </div>
              )}

              {isModerationCase && (
                <>
                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-bold">Case ID:</label>
                    <div>{logData.reportId._id}</div>
                  </div>

                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-bold">Case Type:</label>
                    <div>{getCaseType()}</div>
                  </div>

                  {logData.reportId.severityTag && (
                    <div className="col-md-4 mb-3">
                      <label className="form-label fw-bold">Severity:</label>
                      <div >
                        {logData.reportId.severityTag.toUpperCase()}
                      </div>
                    </div>
                  )}
                </>
              )}


              {!isModerationCase && logData.action !== "coins_added" && logData.action !== "delete_user_photo" && logData.action !== "grant_trial" && (
                <div className="col-md-4 mb-3">
                  <label className="form-label fw-bold">Tier:</label>
                  <div>{logData.tier || "N/A"}</div>
                </div>
              )}

              {!isModerationCase && logData.action !== "coins_added" && logData.action !== "delete_user_photo" && logData.action !== "grant_trial" && (
                <div className="col-md-4 mb-3">
                  <label className="form-label fw-bold">Unlock Type:</label>
                  <div>{logData.unlockType || "N/A"}</div>
                </div>
              )}

              {!isModerationCase && (
                <div className="col-md-4 mb-3">
                  <label className="form-label fw-bold">Permanent:</label>
                  <div>{logData.permanent ? "Yes" : "No"}</div>
                </div>
              )}
              <div className="col-md-4 mb-3">
                <label className="form-label fw-bold">Reason:</label>
                <div>{logData.reason || "N/A"}</div>
              </div>

              <div className="col-md-4 mb-3">
                <label className="form-label fw-bold">Admin:</label>
                <div>
                  {logData?.adminId
                    ? `${logData.adminId.name} (${logData.adminId.email})`
                    : "N/A"}
                </div>
              </div>

              <div className="col-md-4 mb-3">
                <label className="form-label fw-bold">User:</label>
                <div>{logData?.userId?.email || "N/A"}</div>
              </div>

              {logData?.matchedUserId && (
                <div className="col-md-4 mb-3">
                  <label className="form-label fw-bold">Matched User:</label>
                  <div>{logData?.matchedUserId?.email || "N/A"}</div>
                </div>
              )}


              <div className="col-md-4 mb-3">
                <label className="form-label fw-bold">Created At:</label>
                <div>
                  {moment(logData.createdAt).format("DD-MM-YYYY HH:mm:ss")}
                </div>
              </div>
            </div>
            {logData.action === "grant_trial" && (
              renderGrantTrialChanges()
            )}

            {/* Before/After Comparison */}
            {renderBeforeAfter()}
          </div>
        </div>
      </div>
    </div >
  );
};

export default ViewAuditHistoryPageNew;
